import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { useDispatch, useSelector } from "react-redux";

//Tables
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import MyTable from '../utils/MyTable';

import { Checkbox, FormControlLabel, Typography } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import moment from 'moment';

import allActions from '../../actions';
import { ClientDataImportAPI } from '../../API/client_data_import';
import { tabs, unoTheme } from '../../assets/styles/unoTheme';
import MyContentLoadModal from '../utils/MyContentLoadModal';
import MyDatePicker from '../utils/MyDatePicker';
import { MyTab, MyTabs } from '../utils/MyTabs';
import UnoButton from '../utils/UnoButton';
import { applyMaskAccount, applyMaskAmount } from '../utils/utils';

const useStyles = makeStyles((theme) => ({
    contentModal: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
        paddingBottom: theme.spacing(2),
    },

    actionsFlex: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },

    dialogTitle: {
        '& h2': {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            justifyContent: 'space-between'
        }
    },

    tableTh: {
        fontWeight: 'bold'
    },
    green: {
        color: unoTheme.greenMoney,
    },
    red: {
        color: unoTheme.redMoney,
    },
    gray: {
        color: unoTheme.defaultTextColor,
    },
    warningColor: {
        color: unoTheme.warningColor
    },

    tabs: tabs,
    shortWidthTab: {
        '& .MuiTab-root': {
            minWidth: '100px !important',
            width: 'auto',
        }
    },

    ellipsis: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },

    newBadge: {
        color: "white",
        fontSize: "11px",
        padding: "2px 6px",
        fontWeight: "bold",
        background: unoTheme.mainColor,
        borderRadius: "15px",
        whiteSpace: 'nowrap',
    },

    statusCell: {
        background: unoTheme.auxYellowTable,
    },

    periodBar: {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(1),
    },

    infoLine: {
        fontSize: '12px',
        color: unoTheme.defaultTextColor,
    },

    sectionTitle: {
        fontSize: '13px',
        fontWeight: 'bold',
        marginTop: theme.spacing(2),
    },

    sectionHint: {
        fontSize: '12px',
        color: unoTheme.defaultTextColor,
        marginBottom: theme.spacing(1),
    },

    validateMessage: {
        color: unoTheme.redMoney,
        textAlign: 'center',
        padding: '16px',
        backgroundColor: '#eeeeee',
        borderRadius: '5px',
    },

    emptyMessage: {
        fontSize: '12px',
        color: unoTheme.defaultTextColor,
        textAlign: 'center',
        padding: '16px',
    },

}));

const KIND_LABELS = {
    ACCOUNT: 'Conta',
    FUND: 'Fundo',
    TITLE: 'Título',
};

function itemMainLabel(item) {
    if (item.kind === 'ACCOUNT') return 'Conta corrente';
    if (item.kind === 'TITLE') return [item.labelTitleType, item.titleName].filter(el => el).join(' - ');
    return item.name;
}

function itemSecondaryLabel(item) {
    if (item.kind === 'ACCOUNT') return item.instituitionName;
    if (item.kind === 'TITLE') {
        return [
            item.dueDate ? 'Venc: ' + moment.utc(item.dueDate).format('DD/MM/YYYY') : null,
            item.purchaseDate ? 'Aplicação: ' + moment.utc(item.purchaseDate).format('DD/MM/YYYY') : null,
        ].filter(el => el).join(' | ');
    }
    return item.cnpj;
}

/**
 * Célula com o nome do item (conta, fundo ou título) e a linha auxiliar.
 */
function ItemCell({ item, classes }) {
    return (
        <TableCell align="left">
            <Typography className={classes.ellipsis} style={{ fontSize: '12px', fontWeight: 'bold' }}>
                {KIND_LABELS[item.kind] + ': ' + (itemMainLabel(item) || '-')}
            </Typography>
            <Typography className={classes.ellipsis} style={{ fontSize: '11px', color: unoTheme.defaultTextColor }}>
                {itemSecondaryLabel(item) || '-'}
            </Typography>
        </TableCell>
    );
}

/**
 * Sincronização do cadastro em migração com o cadastro oficial de onde ele foi duplicado.
 *
 * Só traz o que o oficial lançou a partir do mês escolhido, e nunca apaga nem altera o que já
 * está na cópia — o que diverge é listado para revisão. A origem não é escolhida aqui: o backend
 * usa a procedência gravada na duplicação. Ver syncPreview/syncExecute em
 * client_data_import.controller.js.
 *
 * @param {object} props
 * @param {boolean} props.open
 * @param {function} props.handleModalSync (open, update)
 */
export default function SyncFromSourceClientModal({ open, handleModalSync }) {

    const classes = useStyles();
    const dispatch = useDispatch();

    const clientOn = useSelector(state => state.clientOn);

    const [loader, setLoader] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const [previewData, setPreviewData] = useState(undefined);
    const [fromPeriod, setFromPeriod] = useState('');
    const [updateUntouchedBalances, setUpdateUntouchedBalances] = useState(false);

    const [tabValue, setTabValue] = useState(0);

    const doPreview = useCallback(async (period) => {

        setErrorMessage('');
        setLoader('Comparando a cópia com o cadastro oficial...');

        const response = await ClientDataImportAPI.syncPreview(clientOn.client.id, period);

        setLoader('');

        if (!response.success) {
            setPreviewData(undefined);
            setErrorMessage(response.body && response.body.message
                ? response.body.message
                : 'Falha ao analisar a sincronização');
            return;
        }

        setPreviewData(response.body);
        setFromPeriod(response.body.fromPeriod);
        setUpdateUntouchedBalances(false);

    }, [clientOn])

    useEffect(() => {

        if (!open || !clientOn || !clientOn.client) return;

        setPreviewData(undefined);
        setFromPeriod('');
        setTabValue(0);
        doPreview(undefined);

    }, [open])

    function handleChangeFromPeriod(value) {

        const period = value ? moment(value) : null;
        if (!period || !period.isValid()) return;

        const formatted = period.format('MM/YYYY');
        if (formatted === fromPeriod) return;

        setFromPeriod(formatted);
        doPreview(formatted);
    }

    const totals = useMemo(() => {

        if (!previewData) return { balances: 0, transactions: 0, newItems: 0, updatable: 0 };

        const months = previewData.months;

        return {
            balances: months.reduce((sum, el) => sum + el.accountBalances + el.fundBalances + el.titleBalances, 0),
            transactions: months.reduce((sum, el) => sum + el.fundTransactions + el.titleTransactions, 0),
            newItems: previewData.included.filter(el => el.syncStatus === 'NEW_IN_WINDOW').length,
            updatable: previewData.divergentBalances.filter(el => el.updatable).length,
        };

    }, [previewData])

    const nothingToDo = totals.balances === 0
        && totals.transactions === 0
        && totals.newItems === 0
        && !(updateUntouchedBalances && totals.updatable > 0);

    const issuesCount = previewData
        ? previewData.divergentBalances.length
        + previewData.transactionConflicts.length
        + previewData.outsideWindowDiffs.length
        : 0;

    async function doSync() {

        setLoader('Sincronizando informações...');

        const response = await ClientDataImportAPI.syncExecute({
            targetClientId: clientOn.client.id,
            fromPeriod: fromPeriod,
            updateUntouchedBalances: updateUntouchedBalances,
        });

        setLoader('');

        if (!response.success) {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: response.body && response.body.message
                    ? response.body.message
                    : 'Falha ao sincronizar as informações',
            }))

            return;
        }

        const { report } = response.body;

        dispatch(allActions.mainAlertActions.setMainAlert({
            show: true,
            type: 'success',
            message: 'Sincronização concluída a partir de ' + report.fromPeriod + ': '
                + report.accountsCreated + ' conta(s), '
                + report.fundAssetsCreated + ' ativo(s) de fundo e '
                + report.titleAssetsCreated + ' título(s) criados, '
                + (report.accountBalancesInserted + report.assetBalancesInserted + report.titleBalancesInserted) + ' saldo(s) e '
                + report.transactionsInserted + ' movimentação(ões) inseridos'
                + (report.balancesUpdated > 0 ? ', ' + report.balancesUpdated + ' saldo(s) atualizados' : ''),
        }))

        handleModalSync(false, true);
    }

    const emptyRow = (colSpan, message) => (
        <TableRow>
            <TableCell colSpan={colSpan} className={classes.emptyMessage}>{message}</TableCell>
        </TableRow>
    );

    return (
        <Dialog
            fullWidth={true}
            maxWidth={'md'}
            open={open}
            PaperProps={{
                style: {
                    height: '90vh',
                },
            }}
            onClose={() => handleModalSync(false)}>

            <DialogTitle className={classes.dialogTitle}>
                <span>{'Sincronizar com o cadastro oficial'}</span>
                {
                    previewData ?
                        <span style={{ fontSize: '14px', color: unoTheme.defaultTextColor }}>
                            {previewData.sourceClient.rpps_name}
                            {' [ ' + previewData.sourceClient.id + ' ] → '}
                            <span style={{ color: unoTheme.mainColor, fontWeight: 'bold' }}>
                                {'cópia [ ' + previewData.targetClient.id + ' ]'}
                            </span>
                        </span>
                        : null
                }
            </DialogTitle>

            <DialogContent className={classes.contentModal}>

                {
                    loader ?
                        <MyContentLoadModal show={true} message={loader} />
                        : null
                }

                {
                    !loader && errorMessage ?
                        <Typography variant="body2" className={classes.validateMessage}>
                            {errorMessage}
                        </Typography>
                        : null
                }

                {
                    !loader && !errorMessage && previewData ?
                        <>
                            <div className={classes.periodBar}>

                                <div>
                                    <Typography className={classes.infoLine}>
                                        {'Lançamentos do cadastro oficial criados depois da cópia começam em '
                                            + (previewData.suggestedFromPeriod || '-')}
                                    </Typography>
                                    <Typography className={classes.infoLine}>
                                        {'Carteira da cópia fechada até: ' + (previewData.targetPortfolioClosed || 'nenhum mês')
                                            + (previewData.effectiveFromPeriod !== previewData.fromPeriod
                                                ? ' — a sincronização começa em ' + previewData.effectiveFromPeriod
                                                : '')}
                                    </Typography>
                                    <Typography className={classes.infoLine}>
                                        {'Nada anterior a ' + previewData.effectiveFromPeriod
                                            + ' é alterado, e nada que já exista na cópia é apagado.'}
                                    </Typography>
                                </div>

                                <MyDatePicker
                                    outerlabel={'Sincronizar a partir de'}
                                    value={fromPeriod ? moment(fromPeriod, 'MM/YYYY') : null}
                                    format="MM/YYYY"
                                    views={['year', 'month']}
                                    openTo="month"
                                    style={{ width: '120px' }}
                                    onChange={(value) => handleChangeFromPeriod(value)}
                                />

                            </div>

                            <div className={[classes.tabs, classes.shortWidthTab].join(' ')} style={{ width: "auto" }}>

                                <MyTabs
                                    value={tabValue}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    onChange={(event, newValue) => setTabValue(newValue)}>

                                    <MyTab label={`Por mês [${previewData.months.length}]`} />
                                    <MyTab label={`Ativos [${previewData.included.length}]`} />
                                    <MyTab label={`Fora da sincronização [${previewData.skipped.length}]`} />
                                    <MyTab label={`Divergências [${issuesCount}]`} />

                                </MyTabs>

                            </div>

                            <div style={{ height: "calc(100% - 140px)", overflowY: 'auto' }}>

                                {
                                    tabValue === 0 &&
                                    <MyTable
                                        style={{ marginTop: '8px' }}
                                        stickyHeader
                                        sizeheaders="verySmall"
                                        size="small">

                                        <TableHead>
                                            <TableRow>
                                                <TableCell className={classes.tableTh} align="center">Mês</TableCell>
                                                <TableCell className={classes.tableTh} align="center">Saldos de conta</TableCell>
                                                <TableCell className={classes.tableTh} align="center">Saldos de fundos</TableCell>
                                                <TableCell className={classes.tableTh} align="center">Saldos de títulos</TableCell>
                                                <TableCell className={classes.tableTh} align="center">Movim. de fundos</TableCell>
                                                <TableCell className={classes.tableTh} align="center">Movim. de títulos</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {
                                                previewData.months.length ?
                                                    previewData.months.map(row => (
                                                        <TableRow key={'sync-month-' + row.period}>
                                                            <TableCell align="center" style={{ fontWeight: 'bold' }}>{row.period}</TableCell>
                                                            <TableCell align="center">{row.accountBalances}</TableCell>
                                                            <TableCell align="center">{row.fundBalances}</TableCell>
                                                            <TableCell align="center">{row.titleBalances}</TableCell>
                                                            <TableCell align="center">{row.fundTransactions}</TableCell>
                                                            <TableCell align="center">{row.titleTransactions}</TableCell>
                                                        </TableRow>
                                                    ))
                                                    : emptyRow(6, 'A cópia já tem tudo o que o cadastro oficial lançou a partir de ' + previewData.effectiveFromPeriod)
                                            }
                                        </TableBody>

                                    </MyTable>
                                }

                                {
                                    tabValue === 1 &&
                                    <MyTable
                                        style={{ marginTop: '8px' }}
                                        stickyHeader
                                        sizeheaders="verySmall"
                                        size="small">

                                        <colgroup>
                                            <col width="8%" />
                                            <col width="44%" />
                                        </colgroup>

                                        <TableHead>
                                            <TableRow>
                                                <TableCell className={classes.tableTh} align="center">Status</TableCell>
                                                <TableCell className={classes.tableTh} align="left">Ativo</TableCell>
                                                <TableCell className={classes.tableTh} align="center">CC</TableCell>
                                                <TableCell className={classes.tableTh} align="center">Ag.</TableCell>
                                                <TableCell className={classes.tableTh} align="center">Saldos</TableCell>
                                                <TableCell className={classes.tableTh} align="center">Movim.</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {
                                                previewData.included.length ?
                                                    previewData.included.map(row => (
                                                        <TableRow key={'sync-included-' + row.kind + '-' + row.sourceId}>
                                                            <TableCell align="center" className={classes.statusCell}>
                                                                {
                                                                    row.syncStatus === 'MATCHED' ?
                                                                        <CheckCircleIcon className={classes.green} />
                                                                        : <span className={classes.newBadge}>{'NOVO!'}</span>
                                                                }
                                                            </TableCell>
                                                            <ItemCell item={row} classes={classes} />
                                                            <TableCell align="center">{row.numberAccount ? applyMaskAccount(row.numberAccount) : '-'}</TableCell>
                                                            <TableCell align="center">{row.agency ? row.agency : '-'}</TableCell>
                                                            <TableCell align="center" className={row.balancesToInsert > 0 ? classes.green : classes.gray}>
                                                                {row.balancesToInsert}
                                                            </TableCell>
                                                            <TableCell align="center" className={row.transactionsToInsert > 0 ? classes.green : classes.gray}>
                                                                {row.transactionsToInsert}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                    : emptyRow(6, 'Nenhum ativo a sincronizar')
                                            }
                                        </TableBody>

                                    </MyTable>
                                }

                                {
                                    tabValue === 2 &&
                                    <>
                                        <Typography className={classes.sectionHint} style={{ marginTop: '8px' }}>
                                            {'Existem no cadastro oficial com histórico anterior a ' + previewData.effectiveFromPeriod
                                                + ' e não foram importados para a cópia. Trazer só os meses recentes deixaria o histórico '
                                                + 'incompleto: se precisarem estar na cópia, use "Importar de outro cliente".'}
                                        </Typography>

                                        <MyTable
                                            stickyHeader
                                            sizeheaders="verySmall"
                                            size="small">

                                            <colgroup>
                                                <col width="48%" />
                                            </colgroup>

                                            <TableHead>
                                                <TableRow>
                                                    <TableCell className={classes.tableTh} align="left">Ativo</TableCell>
                                                    <TableCell className={classes.tableTh} align="center">CC</TableCell>
                                                    <TableCell className={classes.tableTh} align="center">Início</TableCell>
                                                    <TableCell className={classes.tableTh} align="center">Saldos no período</TableCell>
                                                    <TableCell className={classes.tableTh} align="center">Movim. no período</TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {
                                                    previewData.skipped.length ?
                                                        previewData.skipped.map(row => (
                                                            <TableRow key={'sync-skipped-' + row.kind + '-' + row.sourceId}>
                                                                <ItemCell item={row} classes={classes} />
                                                                <TableCell align="center">{row.numberAccount ? applyMaskAccount(row.numberAccount) : '-'}</TableCell>
                                                                <TableCell align="center">{row.firstPeriod || '-'}</TableCell>
                                                                <TableCell align="center" className={classes.warningColor}>{row.balancesToInsert}</TableCell>
                                                                <TableCell align="center" className={classes.warningColor}>{row.transactionsToInsert}</TableCell>
                                                            </TableRow>
                                                        ))
                                                        : emptyRow(5, 'Nenhum ativo fica de fora')
                                                }
                                            </TableBody>

                                        </MyTable>
                                    </>
                                }

                                {
                                    tabValue === 3 &&
                                    <>
                                        <Typography className={classes.sectionTitle}>
                                            {'Saldos que já existem na cópia com valor diferente [' + previewData.divergentBalances.length + ']'}
                                        </Typography>
                                        <Typography className={classes.sectionHint}>
                                            {'Não são alterados. A exceção opcional é o saldo que veio do cadastro oficial e nunca foi '
                                                + 'editado, conciliado ou fechado na cópia (coluna "Atualizável").'}
                                        </Typography>

                                        <MyTable
                                            stickyHeader
                                            sizeheaders="verySmall"
                                            size="small">

                                            <colgroup>
                                                <col width="40%" />
                                            </colgroup>

                                            <TableHead>
                                                <TableRow>
                                                    <TableCell className={classes.tableTh} align="left">Ativo</TableCell>
                                                    <TableCell className={classes.tableTh} align="center">CC</TableCell>
                                                    <TableCell className={classes.tableTh} align="center">Mês</TableCell>
                                                    <TableCell className={classes.tableTh} align="right">Na cópia</TableCell>
                                                    <TableCell className={classes.tableTh} align="right">No oficial</TableCell>
                                                    <TableCell className={classes.tableTh} align="center">Atualizável</TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {
                                                    previewData.divergentBalances.length ?
                                                        previewData.divergentBalances.map((row, index) => (
                                                            <TableRow key={'sync-divergent-' + index}>
                                                                <ItemCell item={row} classes={classes} />
                                                                <TableCell align="center">{row.numberAccount ? applyMaskAccount(row.numberAccount) : '-'}</TableCell>
                                                                <TableCell align="center">{row.period}</TableCell>
                                                                <TableCell align="right">{applyMaskAmount(row.targetBalance || 0, true)}</TableCell>
                                                                <TableCell align="right">{applyMaskAmount(row.sourceBalance || 0, true)}</TableCell>
                                                                <TableCell align="center" className={row.updatable ? classes.green : classes.red}>
                                                                    {row.updatable ? 'Sim' : 'Não'}
                                                                </TableCell>
                                                            </TableRow>
                                                        ))
                                                        : emptyRow(6, 'Nenhum saldo divergente')
                                                }
                                            </TableBody>

                                        </MyTable>

                                        <Typography className={classes.sectionTitle}>
                                            {'Meses não sincronizados por conflito de movimentações [' + previewData.transactionConflicts.length + ']'}
                                        </Typography>
                                        <Typography className={classes.sectionHint}>
                                            {'A cópia tem movimentações que o cadastro oficial não tem. As movimentações do oficial '
                                                + 'nesse mês não são trazidas, para não duplicar uma movimentação editada: ajuste manualmente.'}
                                        </Typography>

                                        <MyTable
                                            stickyHeader
                                            sizeheaders="verySmall"
                                            size="small">

                                            <colgroup>
                                                <col width="48%" />
                                            </colgroup>

                                            <TableHead>
                                                <TableRow>
                                                    <TableCell className={classes.tableTh} align="left">Ativo</TableCell>
                                                    <TableCell className={classes.tableTh} align="center">Mês</TableCell>
                                                    <TableCell className={classes.tableTh} align="center">Só na cópia</TableCell>
                                                    <TableCell className={classes.tableTh} align="center">Só no oficial</TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {
                                                    previewData.transactionConflicts.length ?
                                                        previewData.transactionConflicts.map((row, index) => (
                                                            <TableRow key={'sync-conflict-' + index}>
                                                                <ItemCell item={row} classes={classes} />
                                                                <TableCell align="center">{row.period}</TableCell>
                                                                <TableCell align="center">{row.onlyInTarget}</TableCell>
                                                                <TableCell align="center">{row.onlyInSource}</TableCell>
                                                            </TableRow>
                                                        ))
                                                        : emptyRow(4, 'Nenhum conflito')
                                                }
                                            </TableBody>

                                        </MyTable>

                                        <Typography className={classes.sectionTitle}>
                                            {'Diferenças de movimentações antes de ' + previewData.effectiveFromPeriod
                                                + ' [' + previewData.outsideWindowDiffs.length + ']'}
                                        </Typography>
                                        <Typography className={classes.sectionHint}>
                                            {'Só informativo: estão fora da sincronização e não são tocadas. Podem ser lançamentos '
                                                + 'feitos na cópia ou correções feitas no oficial depois da importação.'}
                                        </Typography>

                                        <MyTable
                                            stickyHeader
                                            sizeheaders="verySmall"
                                            size="small">

                                            <colgroup>
                                                <col width="48%" />
                                            </colgroup>

                                            <TableHead>
                                                <TableRow>
                                                    <TableCell className={classes.tableTh} align="left">Ativo</TableCell>
                                                    <TableCell className={classes.tableTh} align="center">Mês</TableCell>
                                                    <TableCell className={classes.tableTh} align="center">Só na cópia</TableCell>
                                                    <TableCell className={classes.tableTh} align="center">Só no oficial</TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {
                                                    previewData.outsideWindowDiffs.length ?
                                                        previewData.outsideWindowDiffs.map((row, index) => (
                                                            <TableRow key={'sync-outside-' + index}>
                                                                <ItemCell item={row} classes={classes} />
                                                                <TableCell align="center">{row.period}</TableCell>
                                                                <TableCell align="center">{row.onlyInTarget}</TableCell>
                                                                <TableCell align="center">{row.onlyInSource}</TableCell>
                                                            </TableRow>
                                                        ))
                                                        : emptyRow(4, 'Nenhuma diferença')
                                                }
                                            </TableBody>

                                        </MyTable>
                                    </>
                                }

                            </div>
                        </>
                        : null
                }

            </DialogContent>

            {
                !loader ?
                    <DialogActions className={classes.actionsFlex}>

                        <UnoButton onClick={() => handleModalSync(false)} color="secondary">
                            {'Cancelar'}
                        </UnoButton>

                        {
                            previewData && !errorMessage ?
                                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>

                                    {
                                        totals.updatable > 0 ?
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={updateUntouchedBalances}
                                                        color="primary"
                                                        onChange={(e) => setUpdateUntouchedBalances(e.target.checked)}
                                                    />
                                                }
                                                label={
                                                    <Typography style={{ fontSize: '12px' }}>
                                                        {'Atualizar ' + totals.updatable + ' saldo(s) nunca editado(s) na cópia'}
                                                    </Typography>
                                                }
                                            />
                                            : null
                                    }

                                    <Typography style={{ fontSize: '12px', color: unoTheme.defaultTextColor }}>
                                        {totals.newItems + ' ativo(s) novo(s) | '
                                            + totals.balances + ' saldo(s) | '
                                            + totals.transactions + ' movimentação(ões)'}
                                    </Typography>

                                    <UnoButton
                                        disabled={nothingToDo}
                                        onClick={() => doSync()}
                                        type="success">
                                        {'Sincronizar'}
                                    </UnoButton>
                                </div>
                                : null
                        }

                    </DialogActions>
                    : null
            }

        </Dialog>
    );
}
